module.exports = __webpack_public_path__ + "static/media/triplus.bd8c8d4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/paratrioza/preventiva/triplus.png
// module id = 2008
// module chunks = 3